import {getUploadUrlFromFile} from 'rev.sdk.js/Actions/Storage';

export async function uploadRichTextImage(file, {token, signal} = {}) {
  const {url, fields, expected} = await getUploadUrlFromFile(file, {token});

  if (
    typeof url !== 'string' ||
    !/^https?:\/\//.test(url) ||
    !fields ||
    typeof fields !== 'object' ||
    typeof expected !== 'string' ||
    !/^https?:\/\//.test(expected)
  ) {
    throw new Error('無法取得圖片上傳網址');
  }
  if (signal?.aborted) {
    throw new Error('圖片上傳已取消');
  }

  const body = new FormData();
  for (const [key, value] of Object.entries(fields)) {
    body.append(key, value);
  }
  body.append('file', file);

  const response = await fetch(url, {method: 'POST', body, signal});
  if (!response.ok) {
    throw new Error(`圖片上傳失敗 (${response.status})`);
  }

  return {expected};
}
